/* eslint-disable no-console */

function noop () {
  // ignore eslint here, is only dev information
  console.error('noop called (should be never called)', arguments)
}

function errorHandler (error, callback) {
  const statusCode = error?.response?.status || ''

  // if 401 or 403 appears, do nothing, because we handle it directly in the axios plugin (plugins/axios.js)
  if ([401, 403].includes(statusCode)) {
    return
  }

  const errorCallback = this?.$nuxt?.error || callback || (() => console.error('an error appears:', error))
  let message = error

  if (typeof error !== 'string') {
    try {
      message = error.toString()
    } catch (e) {
      message = 'unknown message from error handler'
    }
  }

  const exception = new Error(message)
  exception.statusCode = statusCode

  errorCallback(exception)
}

export {
  noop,
  errorHandler
}
